import { createAsyncThunk } from "@reduxjs/toolkit";
import { createMomentApi, getCalendarPostApi, ReSchedulePostApi } from "../apis";
import { showSnackbar } from "../slices/SnackbarSlice";
import { deletePostApi, editFacebookPostApi, editGBPPostApi, editInstagramPostApi, editPostApi, editWebsitePostApi, editYoutubePostApi, editTiktokPostApi, getPostDetailsApi, ICalendarPost, IReSchedulePost, regenerateYoutubeAudioApi, regenerateYoutubeVideoApi, regenerateTiktokVideoApi, regenerateTiktokAudioApi, retryPostApi, bulkRetryPostApi, updatePostStatusApi } from "../apis/MomentApi";

export const createMomentAction = createAsyncThunk("create/moment", async (payload : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await createMomentApi(payload) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return null
    }
})

export const getCalendarPostAction = createAsyncThunk("get/calendar/post", async (data : ICalendarPost, { rejectWithValue }) => {
    try {
        const response = await getCalendarPostApi(data) 
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error?.message || 'Could not get calendar post')
    }
})

export const getPostDetailsAction = createAsyncThunk("get/post/details", async (data : { post_id: string }, { rejectWithValue }) => {
    try {
        const response = await getPostDetailsApi(data) 
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error?.message || 'Could not get post details')
    }
})

export const ReSchedulePostAction = createAsyncThunk("reschedule/post", async (data : IReSchedulePost, { rejectWithValue , dispatch }) => {
    try {
        const response = await ReSchedulePostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not reschedule post')
    }
})

export const editPostAction = createAsyncThunk("edit/post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit post')
    }
})

export const editGBPPostAction = createAsyncThunk("edit/gbp-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editGBPPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit gbp post')
    }
})

export const editFacebookPostAction = createAsyncThunk("edit/facebook-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editFacebookPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit facebook post')
    }
})

export const editInstagramPostAction = createAsyncThunk("edit/instagram-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editInstagramPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit instagram post')
    }
})

export const editWebsitePostAction = createAsyncThunk("edit/website-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editWebsitePostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit website post')
    }
})

export const editYoutubePostAction = createAsyncThunk("edit/youtube-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editYoutubePostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit youtube post')
    }
})

export const updatePostStatusAction = createAsyncThunk("update/post/status", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await updatePostStatusApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to update post status", type: "error" }));
        return rejectWithValue(error?.message || 'Could not update post status')
    }
})

export const retryPostAction = createAsyncThunk("retry/post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await retryPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        const rawMsg = error?.response?.data?.message || "failed to retry post";

            const formattedMsg = rawMsg
            .replace(/\/breakLine/g, "\n")     
            .replace("Failed to retry post on google_business_profile: ", ""); 

            dispatch(
            showSnackbar({
                message: formattedMsg,
                type: "error",
            })
            );
        return rejectWithValue(error?.message || 'Could not retry post')
    }
})

export const bulkRetryPostAction = createAsyncThunk("bulk-retry/post", async ({ post_ids }: { post_ids: string[] }, { rejectWithValue, dispatch }) => {
    try {
        const response = await bulkRetryPostApi({ post_ids }) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to bulk retry post", type: "error" }));
        return rejectWithValue(error?.message || 'Could not bulk retry post')
    }
})

export const deletePostAction = createAsyncThunk("delete/post", async ({post_ids} : {post_ids: string[]}, { rejectWithValue, dispatch }) => {
    try {
        const response = await deletePostApi({post_ids}) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to retry post", type: "error" }));
        return rejectWithValue(error?.message || 'Could not retry post')
    }
})

export const regenerateYoutubeVideoAction = createAsyncThunk("regenerate/youtube-video", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await regenerateYoutubeVideoApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to regenerate youtube video", type: "error" }));
        return rejectWithValue(error?.message || 'Could not regenerate youtube video')
    }
})

export const regenerateYoutubeAudioAction = createAsyncThunk("regenerate/youtube-audio", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await regenerateYoutubeAudioApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to regenerate youtube audio", type: "error" }));
        return rejectWithValue(error?.message || 'Could not regenerate youtube audio')
    }
})

export const editTiktokPostAction = createAsyncThunk("edit/tiktok-post", async (data : any, { rejectWithValue, dispatch }) => {
    try {
        const response = await editTiktokPostApi(data) 
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.message || 'Could not edit tiktok post')
    }
})

export const regenerateTiktokVideoAction = createAsyncThunk("regenerate/tiktok-video", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await regenerateTiktokVideoApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to regenerate tiktok video", type: "error" }));
        return rejectWithValue(error?.message || 'Could not regenerate tiktok video')
    }
})

export const regenerateTiktokAudioAction = createAsyncThunk("regenerate/tiktok-audio", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await regenerateTiktokAudioApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to regenerate tiktok audio", type: "error" }));
        return rejectWithValue(error?.message || 'Could not regenerate tiktok audio')
    }
})